<template>
    <v-container class="my-5">
        <!--   Diálogo para Mostrar un mensaje al Eliminar Estudiante     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_estudiante')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>

                    <v-btn
                            color="primary"
                            @click="deleteStudent()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('estudiantes') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="450px">
                <template v-slot:activator="{ on }">
                    <v-btn
                            color="primary"
                            dark
                            v-on="on"
                            @click="update = false,
                                cleanFields()"> + {{ $t('anadir_estudiante') }}
                    </v-btn>
                </template>
                <v-form
                        @submit.prevent="update
                        ? updateStudent(id_update)
                        : createStudent()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('estudiantes') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text class="text-center">
                            <v-flex class="pt-3 pb-3 pl-3 pr-3">
                                <v-label>
                                    {{$t('foto_perfil')}}
                                </v-label>
                                <br>
                                <v-avatar
                                        class="profile"
                                        color="grey"
                                        size="200"
                                >
                                    <v-img :src="resultProfileURL"
                                           v-if="resultProfileURL"
                                    >
                                    </v-img>
                                </v-avatar>
                                <br>
                                <v-alert
                                        v-if="errores.avatar"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                >
                                    {{errores.avatar}}
                                </v-alert>
                                <br>
                                <v-btn
                                        color="primary">
                                    <clipper-upload
                                            @input="dialog = false, dialogImageProfile = true, degrees = 0"
                                            accept="image/*"
                                            v-model="imageProfileURL"
                                    >
                                        {{$t('subir_imagen')}}
                                    </clipper-upload>
                                </v-btn>
                            </v-flex>
                            <v-text-field
                                    v-model="first_name"
                                    autofocus
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    :error-messages="errores.first_name"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    :error-messages="errores.last_name"
                            >
                            </v-text-field>
                            <v-autocomplete
                                    v-model="idClassroomStudent"
                                    prepend-icon="mdi-google-classroom"
                                    name="idClassroom"
                                    :item-text="example"
                                    item-value="id"
                                    :label="$t('classrooms')"
                                    :filter="customFilterHouse"
                                    :items="classrooms"
                                    :error-messages="errores.idClassroom"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.grade_name === null ? 'n/a' : data.item.grade_name}} {{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                                </template>
                            </v-autocomplete>
                            <v-autocomplete
                                    v-model="idTutor1"
                                    prepend-icon="mdi-account-supervisor-circle"
                                    name="idTutor1"
                                    :item-text="tutorFullName"
                                    item-value="id"
                                    label="Tutor 1"
                                    :filter="customFilter"
                                    :error-messages="errores.idTutor1"
                                    :items="tutors"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        {{ data.item.first_name }} {{ data.item.last_name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.first_name }} {{ data.item.last_name }}</v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-autocomplete
                                    v-model="idTutor2"
                                    prepend-icon="mdi-account-supervisor-circle"
                                    name="idTutor2"
                                    :item-text="tutorFullName"
                                    item-value="id"
                                    label="Tutor 2"
                                    :filter="customFilter"
                                    :error-messages="errores.idTutor2"
                                    :items="tutors"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        {{ data.item.first_name }} {{ data.item.last_name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.first_name }} {{ data.item.last_name }}</v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-text-field
                                    :value="rfid"
                                    prepend-icon="mdi-tag"
                                    placeholder="F0009198"
                                    name="rfid"
                                    @change="changeRFID"
                                    label="RFID"
                                    :error-messages="errores.unique_number"
                            >
                            </v-text-field>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="clear(),
                                            dialog = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    :loading="loading"
                                    v-if="update"
                                    color="primary"
                                    type="submit"
                            >{{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    :loading="loading"
                                    v-else
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" calign-center>
            <v-flex>
                <v-card class="elevation-5">
                    <v-card-text>
                        <v-layout row wrap class="my-4" calign-center justify-center fill-height>
                            <v-flex xs6>
                                <v-card-title class="justify-center">
                                    <v-text-field
                                            outlined
                                            v-model="search"
                                            prepend-icon="mdi-account-search"
                                            :label="$t('Buscar')"
                                            single-line
                                            hide-details
                                            clearable
                                    ></v-text-field>
                                </v-card-title>
                            </v-flex>
                            <v-flex xs6>
                                <v-card-title class="justify-center">
                                    <v-autocomplete
                                            v-model="idClassroom"
                                            prepend-icon="mdi-google-classroom"
                                            name="idClassroom"
                                            :item-text="example"
                                            item-value="id"
                                            :label="$t('classrooms')"
                                            :filter="customFilterHouse"
                                            :items="classrooms"
                                            no-data-text="Ningún Resultado"
                                            clearable
                                            outlined
                                            autocomplete="off"
                                    >
                                        <template v-slot:item="data">
                                            <strong>{{data.item.grade_name === null ? 'n/a' : data.item.grade_name}} {{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                                        </template>
                                    </v-autocomplete>
                                </v-card-title>
                            </v-flex>
                            <v-flex xs12>
                                <v-data-table
                                        :headers="headers"
                                        :loading="loading_data_students"
                                        :items="students"
                                        :search="search"
                                        class="elevation-1"
                                >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.id }}</td>
                                        <td>{{ props.item.first_name }}</td>
                                        <td>{{ props.item.last_name }}</td>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-icon
                                                medium
                                                color="grey"
                                                class="mr-2"
                                                @click="fillFields(item), update = true, dialog = true, id_update = item.id"
                                        >
                                            mdi-account-edit
                                        </v-icon>
                                        <v-icon
                                                medium
                                                color="red"
                                                @click="deleteDialog = true, idStudentDelete = item.id"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-results>
                                        <v-alert type="warning">
                                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {mapState} from 'vuex'
import Vue from 'vue'
import { required } from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'students',
  created: function () {
    this.getClassrooms()
    this.getTutors()
    this.getStudents()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    update: false,
    id_update: 0,
    first_name: '',
    last_name: '',
    errores: [],
    headers: [],
    students: [],
    tutors: [],
    loading_data_students: false,
    confirmation: '',
    search: '',
    // Imágenes
    dialogImageProfile: false,
    imageProfileURL: '',
    resultProfileURL: '',
    resultAuxProfileURL: '',
    // Delete Manager
    deleteDialog: false,
    idStudentDelete: 0,
    idTutor1: null,
    idTutor2: null,
    loading: false,
    classrooms: [],
    idClassroom: null,
    idClassroomStudent: null,
    degrees: 0,
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      },
      {
        text: 'ID',
        align: 'center',
        sortable: true,
        value: 'idClassroom',
        filter: this.idClassroomFilter
      }
    ]
  },
  computed: {
    ...mapState(['language', 'rfid'])
  },
  methods: {
    changeRFID (e) {
      this.$store.commit('setRFID', e)
    },
    getClassrooms () {
      HTTP.get('classroom/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.classrooms = response.data
      })
      .catch(e => {
        console.log(e)
      })
    },
    getStudents () {
      this.loading_data_students = true
      HTTP.get('student/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.students = response.data
        this.loading_data_students = false
      })
      .catch(e => {
        console.log(e)
        this.loading_data_students = false
      })
    },
    getTutors () {
      HTTP.get('tutor/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.tutors = response.data
      })
      .catch(e => {
        console.log(e)
      })
    },
    example: item => (item.grade_name === null ? 'n/a' : item.grade_name) + ' ' + (item.name === null ? 'n/a' : item.name),
    customFilterHouse (item, queryText) {
      var text = ''
      if (item.grade_name === null || item.grade_name === '') {
        text = 'n/a'
      } else {
        text = item.grade_name.toLowerCase()
      }
      if (item.name === null || item.name === '') {
        text += ' n/a'
      } else {
        text +=  ' ' +  item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    idClassroomFilter (value) {
      // If this filter has no value we just skip the entire filter.
      if (this.idClassroom === null || this.idClassroom === undefined) {
        return true
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      else {
        if (value === null)
          return value
        else
          return value.toLowerCase().includes(this.idClassroom.toLowerCase())
      }
    },
    createStudent () {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      var fileImageProfile = null
      if (this.idTutor1 === undefined) {
        this.idTutor1 = null
      }
      if (this.idTutor2 === undefined) {
        this.idTutor2 = null
      }
      if (this.idClassroomStudent === undefined) {
        this.idClassroomStudent = null
      }
      bodyFormData.set('first_name', this.first_name)
      bodyFormData.set('last_name', this.last_name)
      bodyFormData.set('idClassroom', this.idClassroomStudent)
      bodyFormData.set('idTutor1', this.idTutor1)
      bodyFormData.set('idTutor2', this.idTutor2)
      bodyFormData.set('unique_number', this.rfid)
      if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
        fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
      }
      bodyFormData.append('avatar', fileImageProfile)
      HTTP.post('student/', bodyFormData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        this.getStudents()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_estudiante_alta'))
        this.dialog = false
        setTimeout(this.clear, 3000)
      })
      .catch(e => {
        this.loading = false
        if (e.response.status === 400 && typeof e.response.data === 'object' && e.response.data) {
          if (e.response.data) {
            this.errores = e.response.data
          }
        }
      })
    },
    updateStudent (id) {
      // console.log('ID Student = ', id)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      var fileImageProfile = null
      if (this.idTutor1 === undefined) {
        this.idTutor1 = null
      }
      if (this.idTutor2 === undefined) {
        this.idTutor2 = null
      }
      if (this.idClassroomStudent === undefined) {
        this.idClassroomStudent = null
      }
      if (this.resultProfileURL !== this.resultAuxProfileURL) {
        const newID = this.$uuid.v4()
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
        }
        bodyFormData.append('avatar', fileImageProfile)
      }
      bodyFormData.set('first_name', this.first_name)
      bodyFormData.set('last_name', this.last_name)
      bodyFormData.set('idClassroom', this.idClassroomStudent)
      bodyFormData.set('idTutor1', this.idTutor1)
      bodyFormData.set('idTutor2', this.idTutor2)
      bodyFormData.set('unique_number', this.rfid)
      HTTP.patch('student/' + id, bodyFormData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        this.getStudents()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_estudiante_modificado'))
        this.dialog = false
        setTimeout(this.clear, 3000)
      })
      .catch(e => {
        this.loading = false
        if (e.response.status === 400 && typeof e.response.data === 'object' && e.response.data) {
          if (e.response.data) {
            this.errores = e.response.data
          }
        }
      })
    },
    deleteStudent () {
      HTTP.delete('student/' + this.idStudentDelete, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        // console.log('Manager con ID = ', this.idStudentDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_estudiante_eliminado'))
        this.getStudents()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
      .catch(e => {
        if (e.response.status === 400 && typeof e.response.data === 'object' && e.response.data) {
          this.errores = e.response.data
        }
      })
    },
    clear () {
      this.alerta = false
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    fillFields (item) {
      this.first_name = item.first_name
      this.last_name = item.last_name
      this.idTutor1 = item.idTutor1
      this.idTutor2 = item.idTutor2
      if(item.unique_number === null)
        this.$store.commit('setRFID', '')
      else
        this.$store.commit('setRFID', item.unique_number)
      this.idClassroomStudent = item.idClassroom
      this.resultProfileURL = item.avatar
      this.resultAuxProfileURL = item.avatar
    },
    tutorFullName: item => `${item.first_name} ${item.last_name}`,
    customFilter (item, queryText) {
      const normalize = str => str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
      const fullName = normalize(`${item.first_name} ${item.last_name}`)
      const searchText = normalize(queryText)
      return fullName.indexOf(searchText) > -1
    },
    cleanFields () {
      this.first_name = ''
      this.last_name = ''
      this.idTutor1 = null
      this.idTutor2 = null
      this.$store.commit('setRFID', null)
      this.idClassroomStudent = null
      this.resultProfileURL = ''
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageProfile = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #00A1E4;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
